import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { getXsrfToken } from "../../Store/Security/Actions";
import Modal from "react-modal";
import { I18n } from "react-redux-i18n";
import Utilities from "../../Helpers/Utilities";
import { register, getCompanies } from "../../Store/Account/Actions";
import { toggleBlockingStatus } from "../../Store/Status/Actions";
import { updateCreateAccountModalState } from "../../Store/Modals/Actions";
import { getCountries, getStates, getAddresses } from "../../Store/Checkout/Actions";
Modal.setAppElement("#react-app");

class CreateAccountModal extends Component {
    constructor(props) {
        super(props);

        const { getCountries, getStates, getCompanies, companies, countries, states } = props;

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.renderCountries = this.renderCountries.bind(this);
        this.renderStates = this.renderStates.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);

        if (!countries || countries.length === 0) {
            getCountries(countries => {
                if (!states || states.length === 0) {
                    getStates(countries[0].countryId);
                }
            });
        }

        if (!companies || companies.length === 0) {
            getCompanies();
        }
    }

    openModal() {
        this.props.updateCreateAccountModalState(true);
    }

    closeModal() {
        const { reset, untouch, updateCreateAccountModalState } = this.props;

        reset();
        untouch("FirstName");
        untouch("LastName");
        untouch("UserName");
        untouch("PhoneNumber");
        untouch("City");
        untouch("Address1");
        untouch("Address2");
        untouch("ZipPostalCode");
        untouch("Password");
        untouch("ConfirmPassword");
        updateCreateAccountModalState(false);
    }

    renderTextField(field) {
        const { meta: { touched, error } } = field;
        const className = touched && error ? "has-error" : "";
        const companyClassName = "has-error";
        let companyExists = false;
        const existsError = I18n.t("validation.account.company.exists");

        // if (field.input.name === "Company" && touched) {
        //     companyExists = companyTest(field.input.value);
        // }

        return (
            <div className={companyExists ? companyClassName : className}>
                <input type={field.type} placeholder={field.placeholder} {...field.input} />
                <span className="help-block float-left">{!touched ? "" : companyExists ? existsError : error}</span>
            </div>
        );
    }

    renderCountries() {
        const { countries, companies } = this.props;

        populateCompanies(companies);

        if (countries.length > 0) {
            return _.map(countries, country =>
                <option key={country.countryId} value={country.countryId}>{country.countryName}</option>
            );
        }
    }

    renderStates() {
        const { states } = this.props;

        if (states.length > 0) {
            return _.map(states, state =>
                <option key={state.stateId} value={state.stateId}>{state.stateName}</option>
            );
        }
    }

    onCountryChange(countryId) {
        const { getStates } = this.props;

        getStates(countryId);
    }

    renderErrors() {
        if (this.props.registerStatus.response) {
            const { response: { data } } = this.props.registerStatus;
            if (data) {
                this.props.toggleBlockingStatus(false);

                return (
                    <div className="col-md-12">
                        <div className="alert bg--error" style={{ marginBottom: 0 }}>
                            <div className="alert__body">
                                <span>{data}</span>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    onSubmit(values) {
        const { getXsrfToken, register, reset, toggleBlockingStatus, updateCreateAccountModalState, companies } = this.props;

        toggleBlockingStatus(true);

        let countryId = values.CountryId;
        let stateId = values.StateId;
        let countryName = null;
        let stateName = null;
        let companyExists = false;
        let companyName = "";

        const countryElement = document.getElementsByName("CountryId")[0];
        const stateElement = document.getElementsByName("StateId")[0];

        if (!values.CountryId && countryElement) {
            countryId = countryElement.value;
        }

        if (!values.StateId && stateElement) {
            stateId = stateElement.value;
        }

        if (countryElement) {
            countryName = countryElement.options[countryElement.selectedIndex].text;
        }

        if (stateElement) {
            stateName = stateElement.options[stateElement.selectedIndex].text;
        }

        companyExists = companyTest(values.Company);

        if (companyExists){
            companyName = companies[compIndex];
        }

        const obj = {
            FirstName: Utilities.toTitleCase(values.FirstName).trim(),
            LastName: Utilities.toTitleCase(values.LastName).trim(),
            UserName: Utilities.toTitleCase(values.UserName).trim(),
            Company: companyExists ? companyName : Utilities.toTitleCase(values.Company).trim(),
            PhoneNumber: values.PhoneNumber,
            Password: values.Password,
            ConfirmPassword: values.ConfirmPassword,
            CountryId: countryId,
            CountryName: countryName,
            StateProvinceId: stateId,
            StateProvinceName: stateName,
            City: Utilities.toTitleCase(values.City).trim(),
            Address1: Utilities.toTitleCase(values.Address1).trim(),
            Address2: Utilities.toTitleCase(values.Address2 || "").trim(),
            ZipPostalCode: values.ZipPostalCode.trim()
        };


        getXsrfToken(({ token }) => {
            obj.__RequestVerificationToken = token;

            register(obj, () => {
                reset();
                toggleBlockingStatus(false);
                updateCreateAccountModalState(false);
            });
        });
    }

    render() {
        const { createAccountModalOpen, handleSubmit, countries, states, pristine, submitting } = this.props;

        return (
            <Modal
                isOpen={createAccountModalOpen}
                onRequestClose={this.closeModal}
                contentLabel="create account alert"
                className="modal-content"
                overlayClassName="modal-container create-account-modal modal-active"
            >
                <div className="modal-body">
                    <div className="feature feature-1">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <h3>Create an account</h3>
                                <form id="register-form" style={{ marginTop: 0 }} onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-12">
                                                    <Field
                                                        placeholder={I18n.t("account.company")}
                                                        name="Company"
                                                        type="text"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <Field
                                                        placeholder={I18n.t("account.firstName")}
                                                        name="FirstName"
                                                        type="text"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                    <Field
                                                        placeholder={I18n.t("account.lastName")}
                                                        name="LastName"
                                                        type="text"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <Field
                                                        placeholder={I18n.t("account.email")}
                                                        name="UserName"
                                                        type="email"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                    <Field
                                                        placeholder={I18n.t("account.phoneNumber")}
                                                        name="PhoneNumber"
                                                        type="text"
                                                        normalize={Utilities.normalizePhone}
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <Field
                                                        placeholder={I18n.t("account.password")}
                                                        name="Password"
                                                        type="password"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                    <Field
                                                        placeholder={I18n.t("account.confirmPassword")}
                                                        name="ConfirmPassword"
                                                        type="password"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label>Country</label>
                                                    <div className="input-select">
                                                        <Field name="CountryId" value={countries.length > 0 ? countries[0].id : 0} component="select" onChange={e => this.onCountryChange(e.target.value)}>
                                                            {this.renderCountries()}
                                                        </Field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label>State</label>
                                                    <div className="input-select">
                                                        <Field name="StateId" value={states.length > 0 ? states[0].id : 0} component="select" >
                                                            {this.renderStates()}
                                                        </Field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12" style={{ marginTop: 10 }}>
                                                    <Field
                                                        name="City"
                                                        type="text"
                                                        label="City"
                                                        placeholder="City"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field
                                                        name="Address1"
                                                        type="text"
                                                        label="Address 1"
                                                        placeholder="Address 1"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field
                                                        name="Address2"
                                                        type="text"
                                                        label="Address 2"
                                                        placeholder="Address 2"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field
                                                        name="ZipPostalCode"
                                                        type="text"
                                                        label="Zip / PostalCode"
                                                        placeholder="Postal Code"
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        {this.renderErrors()}
                                        <div className="col-12 create-button-col">
                                            <button type="submit" className="btn btn--primary type--uppercase" disabled={pristine || submitting}>Create Store Account</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        xsrfToken: state.xsrfToken,
        userInfo: state.userInfo,
        registerStatus: state.registerStatus,
        createAccountModalOpen: state.createAccountModalOpen,
        countries: state.countries,
        states: state.states,
        addresses: state.addresses,
        companies: state.companies
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        register: register,
        toggleBlockingStatus: toggleBlockingStatus,
        updateCreateAccountModalState: updateCreateAccountModalState,
        getCountries: getCountries,
        getStates: getStates,
        getAddresses: getAddresses,
        getCompanies: getCompanies
    }, dispatch);
}

function validate(values) {
    const errors = {};

    if (!values.Company) {
        errors.Company = I18n.t("validation.account.company.required");
    }
    if (!values.FirstName) {
        errors.FirstName = I18n.t("validation.account.firstName.required");
    }
    if (!values.LastName) {
        errors.LastName = I18n.t("validation.account.lastName.required");
    }
    if (!values.UserName) {
        errors.UserName = I18n.t("validation.account.email.required");
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.UserName)) {
        errors.UserName = I18n.t("validation.account.email.email");
    }

    if (!values.PhoneNumber) {
        errors.PhoneNumber = I18n.t("validation.account.phoneNumber.required");
    } else if (!/^\(?\d{3}\)?[ ]?\d{3}[- ]?\d{4}$/i.test(values.PhoneNumber)) {
        errors.PhoneNumber = I18n.t("validation.account.phoneNumber.number");
    }

    if (!values.Password) {
        errors.Password = I18n.t("validation.account.password.required");
    }
    if (!values.ConfirmPassword) {
        errors.ConfirmPassword = I18n.t("validation.account.confirmPassword.required");
    }
    if (values.Password && values.ConfirmPassword && values.Password !== values.ConfirmPassword) {
        errors.ConfirmPassword = I18n.t("validation.account.confirmPassword.match");
    }

    if (!values.City) {
        errors.City = I18n.t("validation.address.city.required");
    }
    if (!values.Address1) {
        errors.Address1 = I18n.t("validation.address.address1.required");
    }
    if (!values.ZipPostalCode) {
        errors.ZipPostalCode = I18n.t("validation.address.postalCode.required");
    }

    return errors;
}

var compTest = [];
var compIndex = -1;

function populateCompanies(companies) {
    var commonRemoved = [];
    companies.forEach(company => {
        company = company.toUpperCase();
        if (company.includes(" INC")) {
            company = company.replace(" INC", "");
        }
        if (company.includes(" LLC")) {
            company = company.replace(" LLC", "");
        }
        company = company.replace(/[ ,.]/g, "");

        commonRemoved.push(company);
    });
    compTest = commonRemoved;
}

function companyTest(company) {
    let companyExists = false;
    company = company.toUpperCase();
    if (company.includes(" INC")) {
        company = company.replace(" INC", "");
    }
    if (company.includes(" LLC")) {
        company = company.replace(" LLC", "");
    }
    company = company.replace(/[ ,.]/g, "");

    compIndex = compTest.indexOf(company);
    if (compIndex !== -1){
        companyExists = true;
    }

    return companyExists;
} 

export default reduxForm({
    validate,
    form: "CreateAccount"
})(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateAccountModal))
);